import _ from 'lodash';

const stageWidth = 980;
export const SHARED_PARTS_PREFIX = 'sharedParts';

export const getPrimaryConnectionItem = (connectionItems: any) =>
  _.find(connectionItems, { isPrimary: true });

export const getControllerDefinition = (controllerData: any) => ({
  componentType: 'platform.components.AppWidget',
  data: controllerData,
});

const REF_COMPONENT = 'wysiwyg.viewer.components.RefComponent';

export const isRefHost = ({ componentType }: any) =>
  componentType === REF_COMPONENT;

export const isRefComponent = async (editorSDK: any, componentRef: any) => {
  const type = await editorSDK.components.getType('token', { componentRef });
  return type === REF_COMPONENT;
};

const calcWidgetX = (width: any) => (stageWidth - width) / 2;

export const createAppWidgetInitialDefinition = (controllerData: any) => {
  const defaultChild = {
    componentType: 'wysiwyg.viewer.components.MediaBox',
    components: [],
    type: 'Container',
    skin: 'wysiwyg.viewer.skins.mediaContainer.MediaBox',
    design: {
      type: 'MediaContainerDesignData',
      cssStyle: {},
      themeMappings: {},
    },
    props: {
      type: 'MediaBoxProperties',
      allowOverflowContent: true,
    },
  };
  const defaultStructure = {
    components: [defaultChild],
    layout: {
      width: 500,
      height: 500,
      x: calcWidgetX(500),
      y: 0,
    },
    style: {
      skin: 'platform.components.skins.AppWidgetLoaderSkin',
    },
  };
  return _.defaultsDeep(
    defaultStructure,
    getControllerDefinition(controllerData),
  );
};

export const getUniqueControllerType = (
  widgetPageId: string,
  appDefId: string,
) => `${appDefId}-${widgetPageId}`;
